import React, { useState } from "react";
import { CopyRegular, CheckmarkRegular } from "@fluentui/react-icons";

interface CopyableIdProps {
  value: string;
  style?: React.CSSProperties;
}

/**
 * Displays a text value with a copy-to-clipboard icon that appears on hover.
 * Shows a brief checkmark after successful copy.
 */
export const CopyableId: React.FC<CopyableIdProps> = ({ value, style }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <span
      style={{ display: "inline-flex", alignItems: "center", gap: "0.25rem", maxWidth: "100%", overflow: "hidden", ...style }}
      className="copyable-id"
    >
      <span style={{ fontWeight: 600, color: "#337db6", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={value}>{value}</span>
      <span
        onClick={handleCopy}
        title={copied ? "Copied!" : "Copy to clipboard"}
        aria-label={copied ? "Copied" : `Copy ${value} to clipboard`}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCopy(e as any); } }}
        style={{
          cursor: "pointer",
          opacity: copied ? 1 : 0,
          transition: "opacity 0.15s",
          color: copied ? "#107C10" : "#337db6",
          display: "inline-flex",
          alignItems: "center",
          flexShrink: 0,
        }}
        className="copyable-id-icon"
      >
        {copied ? <CheckmarkRegular fontSize={14} /> : <CopyRegular fontSize={14} />}
      </span>
      <style>{`
        .copyable-id:hover .copyable-id-icon {
          opacity: 1 !important;
        }
      `}</style>
    </span>
  );
};
